import React, { Component, Fragment } from "react";

class NoMatch extends Component {
  render() {
    return <>NoMatch</>;
  }
}

export default NoMatch;
